export default __webpack_public_path__ + "static/media/Braven.5e40c6bd.svg";